<template>
  <div class="box info-box">
    <div class="label font-weight-medium mr-3" v-html="label"></div><strong class="font-weight-medium">{{ value }}</strong>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="stylus" scoped>
  .info-box
    display inline-flex
    align-items center
    justify-content center
    .label
      font-size 20px
    strong
      color $primary
      font-size 40px
</style>
